module.exports = __webpack_public_path__ + "static/media/trial1_3.d367c123.png";